module.exports = __webpack_public_path__ + "assets/fonts/GothamRnd-Book.d31d488d.otf";